import { ReactNode, useState } from "react";
import { useSearchParams } from "react-router-dom";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
import PageHeader from "../PageHeader";
import HomepageContent from "./HomepageContent";
import "./styles.scss";
import { DevUserContext, StageContext } from "../../contexes/OrderIdContext";
import { DEV_USER_PARAM } from "../../helpers/devUser";
import { MarketplaceIdProvider } from "../../contexes/MarketplaceIdContext";
import { HealthStateProvider } from "../../contexes/HealthStateContext";
import { DeferralIdProvider } from "../../contexes/DeferralIdContext";
import { GlProductProvider } from "../../contexes/GlProductContext";
import { Stage } from "../../lusca-search-api/generated-src";

interface Props {
  // Replaces the search bar and landing tabs.
  content?: ReactNode;
}

export default function Homepage({ content }: Props = {}) {
  const [stage, setStage] = useState(null as never as Stage);
  const [searchParams] = useSearchParams();
  const devUser =
    stage === Stage.Dev
      ? searchParams.get(DEV_USER_PARAM) || undefined
      : undefined;

  return (
    <GlProductProvider>
      <HealthStateProvider>
        <MarketplaceIdProvider>
          <DeferralIdProvider>
            <StageContext.Provider value={stage}>
              <DevUserContext.Provider value={devUser}>
                <PageHeader />
                <AppLayout
                  content={content ?? <HomepageContent setStage={setStage} />}
                  contentType="default"
                  headerSelector="#h"
                  maxContentWidth={1700}
                  navigationHide
                  toolsHide
                />
              </DevUserContext.Provider>
            </StageContext.Provider>
          </DeferralIdProvider>
        </MarketplaceIdProvider>
      </HealthStateProvider>
    </GlProductProvider>
  );
}
